import { trpc } from './trpc'
import { inferRouterInputs } from '@trpc/server'
import { AppRouter } from '@tagadapay/trpc-types'

type InputRouter = inferRouterInputs<AppRouter>

export type SaveSignupProfileInput = InputRouter['signupProfile']['save']
export type CompleteHubSignupInput = InputRouter['signupProfile']['completeHubSignup']

/**
 * Hook to save signup profile data during onboarding (requires existing account)
 */
export function useSaveSignupProfile() {
	return trpc.signupProfile.save.useMutation()
}

/**
 * Hook to complete the full hub signup flow (user + org + plan + profile)
 */
export function useCompleteHubSignup() {
	return trpc.signupProfile.completeHubSignup.useMutation()
}
